import React, { useState, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import SelectCustodianForm from "../components/SelectCustodianForm/SelectCustodianForm";
import CardHeader from "../components/CardHeader/CardHeader";
import HeaderWithoutLogin from "../components/HeaderWithoutLogin";
import Card from "../components/Card/Card";
import CustomButton from "../components/CustomButton/CustomButton";
import CustomAlertLabel from "../components/CustomAlertLabel/CustomAlertLabel";
import BackButton from "../components/BackButton/BackButton";

import {
  addOtherCustodians,
  resetCustodian,
  //setGoalToLaunch,
  //resetGoalToLaunch,
} from "../redux/actions";

import styled from "styled-components";
import LoadingBar from "../components/LoadingBar/LoadingBar";

const BodyWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 3%;
  .formContainer__header {
    margin-left: 3em;
    max-width: 80%;
  }

  .buttonContainer {
    margin: 2em;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .errorMessage {
    display: flex;
    flex-direction: row;
  }
`;

const SelectCustodian = () => {
  const {
    addOtherCustodiansSuccess,
    setGoalToLaunchPayLoad,
    //setGoalToLaunchDetails,
  } = useSelector((state) => state.user);

  const [customAlertMessage, setCustomAlertMessage] = useState("");
  const [custodianName, setcustodianName] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoaded, setIsLoaded] = useState(isLoading);
  const dispatch = useDispatch();
  const history = useHistory();

  const goalId = setGoalToLaunchPayLoad?.goalId;

  const handleSubmitButton = () => {
    if (custodianName) {
      setIsLoading(true);
      dispatch(addOtherCustodians(custodianName, goalId));
      setCustomAlertMessage("");
    } else setCustomAlertMessage("The field can't be empty");
  };

  const handleCustomTextBoxKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSubmitButton();
    }
  };

  const handleCustomTextBoxOnBlur = (textBoxName, value) => {
    if (textBoxName === "custodianName") {
      setcustodianName(value);
    }
  };

  // useEffect(() => {
  //   if (setGoalToLaunchDetails) {
  //     dispatch(resetGoalToLaunch());
  //     history.push("/my-goal/:fromdashboard");
  //   }
  // }, [setGoalToLaunchDetails, history, dispatch]);

  useEffect(() => {
    if (addOtherCustodiansSuccess) {
      dispatch(resetCustodian());
      history.push("/strategy-screen/:fromdashboard");
      //dispatch(setGoalToLaunch(setGoalToLaunchPayLoad));
    }
  }, [addOtherCustodiansSuccess, dispatch, history]);

  return (
    <>
      <HeaderWithoutLogin isLogOutButtonVisible={false} />
      {(isLoaded || isLoading) && (
        <LoadingBar isLoading={isLoading} setIsLoaded={setIsLoaded} />
      )}
      <BodyWrapper>
        <div className="formContainer">
          <div className="formContainer__header">
            <CardHeader text={"Let’s help you get set up."} />
            We use your custodian to manage your investment, whether its
            traditional or crypto currency.
          </div>
          <Card>
            <SelectCustodianForm
              handleCustomTextBoxOnBlur={handleCustomTextBoxOnBlur}
              handleCustomTextBoxKeyPress={handleCustomTextBoxKeyPress}
            ></SelectCustodianForm>
          </Card>
          <div className="buttonContainer">
            <BackButton backLogo></BackButton>
            <div>
              <CustomButton
                text="SUBMIT"
                onClick={handleSubmitButton}
                nextLogo
              />
              <CustomAlertLabel message={customAlertMessage} />
            </div>
          </div>{" "}
          <div className="errorMessage"></div>
        </div>
      </BodyWrapper>
    </>
  );
};

export default SelectCustodian;
